function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { forwardRef, useEffect, useState } from '../../../../_snowpack/pkg/react.js';
import styled from '../../../../_snowpack/pkg/styled-components.js'; // @ts-expect-error

import is from '../../../../_snowpack/pkg/styled-is.js';
import Loading from '../../loading/index.js';
import { colors, sizes } from '../../../css/index.js'; // @ts-expect-error

import { Center } from '../../../views/grids/add-edit/styles.js'; // @ts-expect-error

import { Error } from '../../../css/index.js';
import { AsideContent, AsideLoading, AsideLoadingSpinner, AsideSC, CollapseButton, ContentSC, LayoutSC } from './styles.js';
export function Layout(props) {
  const {
    children,
    ...rest
  } = props;
  useEffect(() => {
    const oldBodyOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = oldBodyOverflow;
    };
  }, []);
  return /*#__PURE__*/React.createElement(LayoutSC, rest, children);
}
export const ExpandOverlay = styled.div.withConfig({
  displayName: "main__ExpandOverlay",
  componentId: "sc-1vgsm2x-0"
})(["position:absolute;top:65px;left:0;height:100vh;width:100%;z-index:1;"]);

const Chevron = () => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "183",
  height: "316",
  viewBox: "0 0 183 316"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#4C505B",
  d: "M176,141 L43,8 C38,3 31,0 25,0 C19,0 13,3 8,8 C-2,18 -2,32 8,42 L124,158 L8,274 C-2,284 -2,298 8,308 C18,318 33,318 43,308 L176,175 C181,170 183,164 183,158 C183,151 181,146 176,141 Z"
}));

export function Aside(props) {
  const {
    children,
    loading,
    loadingText = 'Loading...',
    noPadding = false,
    width = sizes.asideWidth,
    hideOverflow
  } = props;
  const [collapsed, setCollapsed] = useState(false);

  const toggleCollapse = () => setCollapsed(s => !s);

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(CollapseButton, {
    collapsed: collapsed,
    onClick: toggleCollapse
  }, /*#__PURE__*/React.createElement(Chevron, null)), /*#__PURE__*/React.createElement(AsideSC, {
    noPadding: noPadding,
    width: width,
    collapsed: collapsed
  }, collapsed && /*#__PURE__*/React.createElement(ExpandOverlay, {
    onClick: toggleCollapse
  }), loading ? /*#__PURE__*/React.createElement(AsideLoading, {
    hidden: collapsed
  }, /*#__PURE__*/React.createElement(AsideLoadingSpinner, {
    size: 15,
    color: colors.lightText
  }), loadingText) : /*#__PURE__*/React.createElement(AsideContent, {
    hidden: collapsed,
    hideOverflow: Boolean(hideOverflow)
  }, children)));
}
export const Content = /*#__PURE__*/forwardRef((props, ref) => {
  const {
    disabled,
    error,
    loading,
    spaceAtTop,
    children,
    center,
    ...rest
  } = props;
  return /*#__PURE__*/React.createElement(ContentSC, _extends({
    className: "scrollable-container",
    $disabled: Boolean(disabled),
    $spaceAtTop: Boolean(spaceAtTop),
    center: Boolean(center),
    ref: ref
  }, rest), loading ? /*#__PURE__*/React.createElement(Loading, {
    transparent: true
  }) : error ? /*#__PURE__*/React.createElement(Center, null, /*#__PURE__*/React.createElement(Error, null, "Oh oh... seems that is nothing to show here...")) : children !== null && children !== void 0 ? children : '');
});
Content.displayName = 'Content';
export const ContentPaper = styled.div.withConfig({
  displayName: "main__ContentPaper",
  componentId: "sc-1vgsm2x-1"
})(["display:grid;grid-template-areas:'margin-left content margin-right';grid-template-columns:minmax(5%,1fr) minmax(auto,1200px) minmax(5%,1fr);height:100%;", ";transition:", ";"], is('center')`
    display: flex;
    align-items: center;
    justify-content: center;
  `, p => p.raised && '0.3s');
export const LayoutBody = styled.div.withConfig({
  displayName: "main__LayoutBody",
  componentId: "sc-1vgsm2x-2"
})(["flex:1 1 auto;overflow:hidden;height:100%;"]);
export const getEditUrl = url => {
  if (url.endsWith('/')) {
    return `${url}edit`;
  }

  return `${url}/edit`;
};